import { PAYMENT_SYSTEM, TRANSFER_DEFAULT_PROJECT_NAME } from "./consts";

export const removeTransferFromCollection = (collection) => {
  return collection.filter((item) => {
    return item.name !== TRANSFER_DEFAULT_PROJECT_NAME && item.name !== PAYMENT_SYSTEM.BALANCE_TRANSFER;
  });
};

export const removeDuplicatesFromConnectionsCollectionByServiceId = (connections) => {
  const seen = new Set();

  return connections.filter(connection => {
    const duplicate = seen.has(connection.service.id);
    seen.add(connection.service.id);
    return !duplicate;
  });
}

export const isEmptyCollectionValue = (object, fieldsForDisableValidation = []) => {
  let result = false;
  for (let [propKey, propValue] of Object.entries(object)) {
    if (!fieldsForDisableValidation.includes(propKey) && (propValue === null || propValue === undefined)) {
      result = true;
      break;
    }
  }

  return result;
};